import bus from '../connection/checkoutConnection';
import checkoutService from './checkout.service';
import {
    addExpressSnapshot,
    cancelPayment,
    completePayment,
    lockPayment,
    lockPosProcessingPayment,
    setPaymentLoading,
    unlockPayment,
    unlockPosProcessingPayment,
    updatePayment,
    updatePayments,
    verifyPayment,
} from './checkout.store';
import integrityCheckService from '@/integrityCheck/integrityCheck.service';

export default () => [
    bus.subscribe('broadcastPayment', (data) =>
        // TODO: parse data
        updatePayment(checkoutService.transformIncomingPayment(data as any, bus.config.storeGuid ?? '') as any),
    ),
    bus.subscribe('posBackchannelResultAvailable', (data) =>
        // TODO: parse data
        updatePayment(checkoutService.transformIncomingPayment(data as any, bus.config.storeGuid ?? '') as any),
    ),

    bus.subscribe('paymentCompleted', (data) => {
        // TODO: parse data
        completePayment(data as any);
    }),

    bus.subscribe('paymentCancelled', (data) => {
        // TODO: parse data
        cancelPayment(data as any);
    }),

    bus.subscribe('paymentVerify', (data) => {
        // TODO: parse data
        verifyPayment(data as any);
    }),

    bus.subscribe('paymentLock', (data) => {
        // TODO: parse data
        lockPayment(data as any);
    }),

    bus.subscribe('paymentUnlock', (data) => {
        // TODO: parse data
        unlockPayment(data as any);
    }),

    bus.subscribe('postProcessingPaymentLock', (data) => {
        // TODO: parse data
        lockPosProcessingPayment(data as any);
    }),

    bus.subscribe('postProcessingPaymentUnlock', (data) => {
        // TODO: parse data
        unlockPosProcessingPayment(data as any);
    }),

    bus.subscribe('expressSnapshot', (data) => {
        // TODO: parse data
        addExpressSnapshot(data as any);
    }),

    bus.subscribe('basketIntegrityCheck', (data: any) => {
        // TODO: parse data
        integrityCheckService
            .getIntegrityCheckItem({
                storeGuid: bus.config.storeGuid ?? '',
                paymentRequestGuid: data.paymentRequestGuid,
            })
            .updateValue(data);
    }),

    bus.onConnection(
        () => checkoutService.getPendingRequests(bus.config.storeGuid ?? '').then((data) => updatePayments(data as any)),
        (loading) => setPaymentLoading(loading),
    ),
];
